import {Course, SchoolClass, SchoolClassCourse} from "models"
import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useI18n, View} from "shared/base"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import {Image} from "react-native"
import Link from "@kaspernj/api-maker/build/link"
import React from "react"
import Routes from "shared/routes"

export default memo(shapeComponent(class RoutesUserSchoolClassesClassSpaceCourseCardSmall extends ShapeComponent {
  static defaultProps = {
    schoolClassCourse: null
  }

  static propTypes = propTypesExact({
    course: PropTypes.instanceOf(Course).isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired,
    schoolClassCourse: PropTypes.instanceOf(SchoolClassCourse)
  })

  setup() {
    const {t} = useI18n({namespace: "js.routes.user.school_classes.class_space.continue_working_on"})

    this.setInstance({t})
  }

  render() {
    const {course, schoolClass, schoolClassCourse} = this.p
    const courseGroup = course.courseGroups().loaded()[0]
    let to

    if (schoolClassCourse) {
      to = Routes.userCoursePath(course.id(), {school_class_course_id: schoolClassCourse.id()})
    } else {
      to = Routes.userCoursePath(course.id(), {school_class_id: schoolClass.id()})
    }

    return (
      <Link to={to}>
        <Image source={course.backgroundImageUrl()} style={this.courseBackgroundImageStyle ||= {width: 290, height: 180, marginBottom: 12, borderRadius: 40}} />
        <Text style={this.courseNameStyle ||= {color: "#2c2c96", fontSize: 28, fontWeight: 700}}>
          {course.name()}
        </Text>
        <View style={this.textViewStyle ||= {flexDirection: "row", alignItems: "center"}}>
          {courseGroup &&
            <View style={this.iconAndNameContainerStyle ||= {flexDirection: "row", alignItems: "center"}}>
              <Icon color="#87a2d5" name={courseGroup.icon() || "pencil"} size={18} />
              <Text style={this.courseGroupNameStyle ||= {marginLeft: 12, color: "#87a2d5", fontFamily: "HankenGrotesk", fontSize: 20, fontWeight: 700}}>
                {courseGroup.name()}
              </Text>
            </View>
          }
          {course.hasEstimatedTime() &&
            <>
              <Text style={this.dashStyle ||= {marginLeft: 12, marginRight: 12, color: "#87a2d5", fontFamily: "HankenGrotesk", fontSize: 24, fontWeight: 400}}>
                -
              </Text>
              <Text style={this.estimatedTimeTextStyle ||= {color: "#87A2D5", fontFamily: "HankenGrotesk", fontSize: 20, fontWeight: 400}}>
                {course.estimatedTime()}
              </Text>
            </>
          }
        </View>
      </Link>
    )
  }
}))
